jQuery( function ( $ ) {
    'use strict';
    // here for each comment reply link of wordpress
    $( '.comment-reply-link' ).addClass( 'btn btn-primary' );

    // here for the submit button of the comment reply form
    $( '#commentsubmit' ).addClass( 'btn btn-primary' );

    // The WordPress Default Widgets
    // Now we'll add some classes for the wordpress default widgets - let's go

    // the search widget
    $( '.widget_search input.search-field' ).addClass( 'form-control' );
    $( '.widget_search input.search-submit' ).addClass( 'btn btn-default' );
    $( '.variations_form .variations .value > select' ).addClass( 'form-control' );
    $( '.widget_rss ul' ).addClass( 'media-list' );

    $( '.widget_meta ul, .widget_recent_entries ul, .widget_archive ul, .widget_categories ul, .widget_nav_menu ul, .widget_pages ul, .widget_product_categories ul' ).addClass( 'nav flex-column' );
    $( '.widget_meta ul li, .widget_recent_entries ul li, .widget_archive ul li, .widget_categories ul li, .widget_nav_menu ul li, .widget_pages ul li, .widget_product_categories ul li' ).addClass( 'nav-item' );
    $( '.widget_meta ul li a, .widget_recent_entries ul li a, .widget_archive ul li a, .widget_categories ul li a, .widget_nav_menu ul li a, .widget_pages ul li a, .widget_product_categories ul li a' ).addClass( 'nav-link' );

    $( '.widget_recent_comments ul#recentcomments' ).css( 'list-style', 'none').css( 'padding-left', '0' );
    $( '.widget_recent_comments ul#recentcomments li' ).css( 'padding', '5px 15px');

    $( 'table#wp-calendar' ).addClass( 'table table-striped');

    // Adding Class to contact form 7 form
    $('.wpcf7-form-control').not(".wpcf7-submit, .wpcf7-acceptance, .wpcf7-file, .wpcf7-radio").addClass('form-control');
    $('.wpcf7-submit').addClass('btn btn-primary');

    // Adding Class to Woocommerce form
    $('.woocommerce-Input--text, .woocommerce-Input--email, .woocommerce-Input--password').addClass('form-control');
    $('.woocommerce-Button.button').addClass('btn btn-primary mt-2').removeClass('button');

    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('open');
        $(this).parent().toggleClass('open');
    });

    // Fix woocommerce checkout layout
    $('#customer_details .col-1').addClass('col-12').removeClass('col-1');
    $('#customer_details .col-2').addClass('col-12').removeClass('col-2');
    $('.woocommerce-MyAccount-content .col-1').addClass('col-12').removeClass('col-1');
    $('.woocommerce-MyAccount-content .col-2').addClass('col-12').removeClass('col-2');

    // Add Option to add Fullwidth Section
    function fullWidthSection(){
        var screenWidth = $(window).width();
        if ($('.entry-content').length) {
            var leftoffset = $('.entry-content').offset().left;
        }else{
            var leftoffset = 0;
        }
        $('.full-bleed-section').css({
            'position': 'relative',
            'left': '-'+leftoffset+'px',
            'box-sizing': 'border-box',
            'width': screenWidth,
        });
    }
    fullWidthSection();
    $( window ).resize(function() {
        fullWidthSection();
    });

    // Allow smooth scroll
    $('.page-scroller').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').animate({
            'scrollTop': $target.offset().top
        }, 1000, 'swing');
    });

    if ( $('body').hasClass('legendy') ){
        $('.legendy .nav-previous').prepend('<p>Poprzednia legenda</p>');
        $('.legendy .nav-next').prepend('<p>Nastepna legenda</p>');
    }
    else{
        $('.nav-previous').prepend('<p>Poprzedni artykuł</p>');
        $('.nav-next').prepend('<p>Nastepny artykuł</p>');
    }

    $('.post-navigation').addClass('bottom-border');
    $('.comment-reply-link').removeClass('btn btn-primary');
    $('#commentsubmit').removeClass('btn btn-primary');
    $('.form-submit').addClass('hvr-ripple-out');
    $('.player-number').fitText(1.2, { minFontSize: '300px', maxFontSize: '377px' });
   /* $('.home .player-name').fitText(1.2, { minFontSize: '0px', maxFontSize: '68px' });*/

    $('#commentsubmit').click(function(){
        var form = $('#commentform');
        
        $.validator.addMethod("validateEmail", function(value, element) {
            return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@(?:\S{1,63})$/.test( value );
          }, 'Proszę podać prawidłowy adres email.');

        form.validate({
            rules: {
                author: {
                    required: true
                  },
                email: {
                    required: true,
                    validateEmail: true
                }
            },
            messages: {
                author: "To pole jest wymagane",
                email: "Podaj poprawny email."
              },
            errorElement: "div",
            errorPlacement: function(error, element) {
                element.after(error);
            }       
        });

    });

    var el = $('.aiowps-captcha').clone();
    $('.aiowps-captcha').remove();
    $('.aiowps-captcha-equation').append(el);

    $('#main-slider').carousel({
        interval: 3000
    });

    $('.pie_progress').asPieProgress({
        namespace: 'pie_progress',
        size: 170,
        speed: 50, // speed of 1/100
        barcolor: '#075123',
        barsize: '10',
        trackcolor: '#cbcccc',
        easing: 'ease',
    });
     
    $('.stats').viewportChecker({
        classToAdd: 'visible',
        classToRemove : 'invisible',
        offset: 200,
        callbackFunction: function(elem, action){
            $('.count').each(function () {
                var endVal = $(this).prop('Counter',0).text();
                $(this).prop('Counter',0)
                .animate({
                    Counter: $(this).text()
                }, {
                    duration: 1500,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    },     
                    complete: function(now) {
                        $(this).text(endVal);
                    }
                });
            });

            $('.pie_progress').asPieProgress('start');
        }
    });


    $('.filter').click(function(){
        $('.filter ul').slideToggle(150, function () {
            $(this).toggleClass('active');
        });
    });
/*
    $('.filter li').click(function(){
        var year = $(this).text();
	 document.getElementById("sezon").innerHTML = 'Sezon ' + year;
		var yearShort = year.substr(0, 4);

        $('.game-item').hide();

        if ( year == 'All' ){
            $('.game-item').fadeIn('slow');   
        }
        else{
            $('.game-item[data-year="' + yearShort + '"]').fadeIn('slow');   
        }

    });
*/

    $(".lightgallery").lightGallery({
        thumbnail:true,
    }); 


    $('.show-gallery').on('click', function(e) {
        var data = $.parseJSON( $(this).attr('data-img') );
        var images = [];
        var img = {};

        data.forEach(function(el) {
            img = {
                src: el,
                thumb: el
            }
            images.push(img);
        });

        $(this).lightGallery({
            dynamic: true,
            dynamicEl: images
        });
    });
    
    
    $('#partners-carousel').on('slide.bs.carousel', function (e) {
        var $e = $(e.relatedTarget);
        var idx = $e.index();
       
        if ( $( window ).width() > 768 ){
            var itemsPerSlide = 6;
        }
        else if  ( $( window ).width() < 768 && $( window ).width() > 576){
            var itemsPerSlide = 4;
        }
        else {
            var itemsPerSlide = 3;
        }
        
        var totalItems = $('#partners-carousel .carousel-item').length;
        
        if (idx >= totalItems-(itemsPerSlide-1)) {
            var it = itemsPerSlide - (totalItems - idx);
            for (var i=0; i<it; i++) {
                // append slides to end
                if (e.direction=="left") {
                    $('#partners-carousel .carousel-item').eq(i).appendTo('#partners-carousel .carousel-inner');
                }
                else {
                    $('#partners-carousel .carousel-item').eq(0).appendTo('#partners-carousel .carousel-inner');
                }
            }
        }
    });

    jQuery('#partners-carousel').carousel({ 
        interval: 1500
    });
});

